var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-icon',_vm._g(_vm._b({attrs:{"size":"24"},on:{"click":_vm.volver}},'v-icon',attrs,false),on),[_vm._v(" "+_vm._s(_vm.volverIcon)+" ")])]}}])},[_c('span',[_vm._v("Atrás")])])
}
var staticRenderFns = []

export { render, staticRenderFns }